import React from "react";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@mui/icons-material";

const TopBanner = ({ message, icon, cta, buttonText, navigateTo }) => {
  const navigate = useNavigate();
  const [showBanner, setShowBanner] = React.useState(true);
  return (
    showBanner && (
    <div className="bg-black text-white py-2 px-4 flex items-center justify-between">
      <div className="flex items-center space-x-2">
        <span className="flex-shrink-0">{icon}</span>
        <div className="flex flex-col sm:flex-row sm:items-center sm:space-x-2">
          <p className="font-semibold">{cta}</p>
          <p>{message}</p>
        </div>
      </div>
      <div className="flex items-center space-x-4">
        <button
          className="bg-white text-blue-600 px-4 py-1 rounded-full font-semibold hover:bg-blue-100 transition duration-300"
          onClick={() => {
            navigate(`/${navigateTo}`);
          }}
        >
          {buttonText}
        </button>
        <CloseOutlined onClick={(() => {setShowBanner(false)})} className="cursor-pointer hover:text-gray-200 transition-colors duration-300" />
      </div>
    </div>
  )
  );
};

export default TopBanner;
